<template>
    <Dropdown trigger="click" placement="left-start" style="font-size: 22px;" v-if="options.length > 0">
        <a style="color:#515a73;">
            <Icon type="md-more"></Icon>
        </a>
        <DropdownMenu slot="list">
            <DropdownItem v-for="(option, key) in options" :key="key" @click.native='onSelect(id, uuid, option.label,key+1)'
                          :style="{ color: option.textColor || '#515a73'}">
                <Icon :type="option.icone"/>
                {{ option.label }}
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
</template>
<script>
    export default {
        props: {
            id: Number,
            uuid: String,
            onSelect: Function,
            options: Array
        }
    };
</script>